import { render } from "./article-detail.vue?vue&type=template&id=75cb7d9e&scoped=true&ts=true"
import script from "./article-detail.vue?vue&type=script&lang=ts"
export * from "./article-detail.vue?vue&type=script&lang=ts"

import "./article-detail.vue?vue&type=style&index=0&id=75cb7d9e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cb7d9e"]])

export default __exports__